import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http'
import {Injectable, inject} from '@angular/core'
import {UveLogKey} from '@models/constants/log-key'
import {LoggingService} from '@service/logging.service'
import {SessionService} from '@uve-solutions/api-angular-client'
import {Observable, tap} from 'rxjs'

const DEDUP_WINDOW_MS = 60_000

@Injectable()
export class UnauthorizedLoggingInterceptor implements HttpInterceptor {
  #lastLoggedToken: string | null = null
  #lastLoggedTime = 0

  private readonly loggingService = inject(LoggingService)
  private readonly sessionService = inject(SessionService)

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap({
        error: (error: HttpErrorResponse) => {
          if (error.status === HttpStatusCode.Unauthorized) {
            this.#handleUnauthorized(error, request.url)
          }
        },
      })
    )
  }

  #handleUnauthorized(error: HttpErrorResponse, url: string): void {
    const token = this.sessionService.currentToken?.() ?? null
    const now = Date.now()

    if (token === this.#lastLoggedToken && now - this.#lastLoggedTime < DEDUP_WINDOW_MS) {
      return
    }

    this.#lastLoggedToken = token
    this.#lastLoggedTime = now

    const responseBody = this.#extractResponseBody(error)

    this.loggingService.error(UveLogKey.Error.SessionExpired401, {
      url,
      tokenPrefix: token ? `${token.substring(0, 10)}...` : null,
      ...(responseBody ? {responseBody} : {}),
    })
  }

  #extractResponseBody(error: HttpErrorResponse): string | null {
    if (!error.error) {
      return null
    }
    if (typeof error.error === 'string') {
      return error.error
    }
    try {
      return JSON.stringify(error.error)
    } catch {
      return null
    }
  }
}
